<template>
  <deals-Items :coupons="coupons" :isHome="false" ></deals-Items>
</template>
<script>
import DealsItems from '@/views/components/DealsItems'
export default {
  name:'deals',
  components: {
    DealsItems
  },
  props: {
    coupons:Array
  },
  mounted() {
  }
};
</script>
